import { ChangeEvent, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useToast } from '../ui/use-toast'
import { usersService } from '../../../app/services/usersService'
import { UserDisableReason } from '@/app/services/usersService/userDisable'

export const useBlockAndUnblockController = () => {
  const { id } = useParams()
  const queryClient = useQueryClient()
  const [textAreaValue, setTextAreaValue] = useState('')
  const [isTextAreaValid, setIsTextAreaValid] = useState(false)

  const { toast } = useToast()

  const handleBlockReason = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const value = event.target.value
    setTextAreaValue(value)
    setIsTextAreaValid(value.length >= 5)
  }

  const { mutateAsync: enableMutate, isPending: enableIsPending } = useMutation(
    {
      mutationFn: async (id: string) => {
        return usersService.userEnable(id)
      },
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: ['Allsellers'],
        })
        queryClient.invalidateQueries({
          queryKey: ['sellerInfo', id],
        })
      },
    },
  )

  const handleEnableUser = async (id: string) => {
    try {
      if (id) {
        const response = await enableMutate(id)

        if (response.success) {
          toast({
            title: 'Usuário desbloqueado com sucesso!',
          })
        }
      }
    } catch (error) {
      console.log(error)
      toast({
        title: 'Erro ao desbloquear o usuário.',
      })
    }
  }

  const { mutateAsync: disableMutate, isPending: disableIsPending } =
    useMutation({
      mutationFn: async ({
        id,
        reason,
      }: {
        id: string
        reason: UserDisableReason
      }) => {
        return usersService.userDisable(id, reason)
      },
      onSuccess() {
        queryClient.invalidateQueries({
          queryKey: ['Allsellers'],
        })
        queryClient.invalidateQueries({
          queryKey: ['sellerInfo', id],
        })
      },
    })

  const handleDisableUser = async (id: string) => {
    try {
      if (id) {
        if (isTextAreaValid) {
          const response = await disableMutate({
            id,
            reason: { reason: textAreaValue },
          })
          if (response.success) {
            toast({
              title: 'Usuário bloqueado com sucesso!',
            })
          }
        }
      }
    } catch (error) {
      console.log(error)
      toast({
        title: 'Erro ao bloquear o usuário.',
      })
    }
  }

  return {
    enableIsPending,
    handleEnableUser,
    disableIsPending,
    handleDisableUser,
    handleBlockReason,
    textAreaValue,
    isTextAreaValid,
  }
}
